function QuizQuestionTracker({ questions, answers, currentIndex, onJump }) {
    return (
        <div className="flex flex-wrap gap-2 mb-6">
            {questions.map((q, idx) => {
                const answer = answers[q.id];
                let isAnswered = false;
                if (q.question_type === 'objective') {
                    isAnswered = !!answer?.selected_option;
                } else if (q.question_type == 'multiple_select'){
                    isAnswered = answer?.selected_options?.length > 0

                } else if (q.question_type === 'theory') {
                    isAnswered = !!answer?.theory_answer?.trim();
                } else if (q.question_type === 'matching') {
                    isAnswered = Array.isArray(answer?.matching_answers) && answer.matching_answers.length === q.matching_pair.length;
                }
                return (
                    <button
                        key={q.id}
                        className={`w-8 h-8 rounded-full border text-xs font-bold
              ${idx === currentIndex ? 'bg-primary text-white border-primary' : ''}
              ${isAnswered ? 'bg-green-100 border-green-400 text-green-800' : 'bg-gray-100 border-gray-300 text-gray-500'}
              hover:ring-2 hover:ring-primary transition`}
                        onClick={() => onJump(idx)}
                        type="button"
                        aria-label={`Go to question ${idx + 1}`}
                    >
                        {idx + 1}
                    </button>
                );
            })}
        </div>
    );
}

export default QuizQuestionTracker;
